var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunrise3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180.96 77.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.17,50.21c0-15.64,12.68-28.32,28.32-28.32s28.32,12.68,28.32,28.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.49,
    y1: 15.2,
    x2: 90.49,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.92,
    y1: 21.9,
    x2: 61.87,
    y2: 10.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 57.22,
    y1: 39.42,
    x2: 44.19,
    y2: 35.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.81,
    y1: 39.36,
    x2: 136.83,
    y2: 35.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 111.07,
    y1: 21.87,
    x2: 119.12,
    y2: 10.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    y1: 50.21,
    x2: 179.46,
    y2: 50.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.16,
    y1: 63.28,
    x2: 159.82,
    y2: 63.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.59,
    y1: 76.36,
    x2: 147.37,
    y2: 76.36
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise3);
export default __webpack_public_path__ + "static/media/Sunrise3.39aa7f4ec5621fc9e3d471d5eb965c55.svg";
export { ForwardRef as ReactComponent };